export default __webpack_public_path__ + "static/media/turizo.1981f72f.png";